import { useCallback } from "react";
import { HttpErrorType } from "../../types";
import { useUserSessionContext } from "../../contexts/UserSessionContext";
import { notifyError } from "../../utils";

export const useHttpErrorHandler = () => {
  const { logoutUser } = useUserSessionContext();
  const handleHttpError = useCallback(
    (error: HttpErrorType) => {
      if (error.status === 401) {
        logoutUser();
      } else {
        notifyError(error.message);
      }
    },
    [logoutUser],
  );
  return {
    handleHttpError,
  };
};
